import ge from "./in-app-message-manager.js";
import e from "../managers/braze-instance.js";
const pe = {
  _e: null,
  t: !1,
  m: () => (
    pe.o(), pe._e || (pe._e = new ge(e.nr(), e.g(), e.l(), e.p())), pe._e
  ),
  o: () => {
    pe.t || (e.u(pe), (pe.t = !0));
  },
  destroy: () => {
    (pe._e = null), (pe.t = !1);
  }
};
export default pe;
